import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/periods', config);
}

const get = async (code) => {
    return FinanceApi.get('/periods/' + code);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/periods/' + data.id, data);
    }
    return FinanceApi.post('/periods', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/periods/' + id, formData);
}

const deletePeriod = async (id) => {
    return FinanceApi.delete('/periods/' + id);
}

export default {
    getAll,
    get,
    store,
    update,
    deletePeriod
}
